export const environment = {
  production: false,
  guestDuration: 7,
};
